import {useLayoutEffect} from 'react';
import {SessionStorage} from '@chekin/core';
import {useIVStore} from '@chekin/shared';
import {useIVLockStore} from 'hooks/iv/ivLockStore';

export const GUEST_DRAFT_OWNER_KEY = 'GUEST_DRAFT_RESERVATION_ID';

export function useGuestDraftOwner(reservationId?: string | null) {
  useLayoutEffect(() => {
    if (!reservationId) return;

    const owner = SessionStorage.get<string>(GUEST_DRAFT_OWNER_KEY);
    if (owner && String(owner) !== String(reservationId)) {
      SessionStorage.clear();
      useIVStore.getState().resetAllIVState();
      useIVLockStore.getState().clear();
    }
    SessionStorage.set(GUEST_DRAFT_OWNER_KEY, String(reservationId));
  }, [reservationId]);
}
